import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import * as types from './types';
import { fetchWishlist, addWishlistItem as _addWishlistItem, deleteWishlistItem as _deleteWishlistItem } from '~/services/wishlist';
export default {
  fetchWishlistItems: function fetchWishlistItems(_ref) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, _yield$fetchWishlist, wishlist;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return fetchWishlist(_this);

            case 3:
              _yield$fetchWishlist = _context.sent;
              wishlist = _yield$fetchWishlist.wishlist;
              commit(types.SET_WISHLIST_ITEMS, wishlist);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  addWishlistItem: function addWishlistItem(_ref2, reference) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.prev = 1;
              _context2.next = 4;
              return _addWishlistItem(_this2, reference);

            case 4:
              commit(types.ADD_WISHLIST_ITEM, {
                product: {
                  reference: reference
                }
              });
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _this2.$logger.error(_context2.t0);

              throw new Error('ADD_WISHLIST_FAILED');

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }))();
  },
  deleteWishlistItem: function deleteWishlistItem(_ref3, reference) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              _context3.prev = 1;
              _context3.next = 4;
              return _deleteWishlistItem(_this3, reference);

            case 4:
              commit(types.DELETE_WISHLIST_ITEM, reference);
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);

              _this3.$logger.error(_context3.t0);

              throw new Error('REMOVE_WISHLIST_FAILED');

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7]]);
    }))();
  }
};